// src/utils/whatsappUtils.js

const WHATSAPP_NUMBER = "966595014100";

/**
 * @param {string} serviceTitle - The name of the service
 * @param {string} pageName - The name of the page sending the request
 */
export const openWhatsApp2 = (serviceTitle = "استفسار عام", pageName = "الموقع الإلكتروني") => {
  const message = `
السلام عليكم،

أرغب بالحصول على عرض سعر للخدمة التالية:
${serviceTitle}

تم الإرسال من صفحة:
${pageName}
  `.trim();

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, "_blank");
};